module.exports = __webpack_public_path__ + "static/media/ico-linux.6f189bd6.svg";